import { render } from "./video.vue?vue&type=template&id=d9673374&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=d9673374&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9673374"]])

export default __exports__